var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80868 3.69674L11.4382 2.71067C11.6461 2.63271 11.75 2.59373 11.857 2.57828C11.9518 2.56457 12.0482 2.56457 12.143 2.57828C12.25 2.59373 12.3539 2.63271 12.5618 2.71067L17.9236 4.72135C18.6722 5.00208 19.0465 5.14244 19.3223 5.38553C19.566 5.60028 19.7537 5.87114 19.8692 6.1747C20 6.51833 20 6.91809 20 7.7176V12.5C20 13.2203 19.8847 13.9118 19.6818 14.571M17.6219 18.1257C15.9362 20.086 13.7879 21.4789 12.6996 22.1139C12.4772 22.2437 12.366 22.3086 12.2098 22.3421C12.0885 22.3681 11.9116 22.3681 11.7904 22.3421C11.6341 22.3086 11.5234 22.244 11.302 22.1149C9.35396 20.9784 4 17.4084 4 12.5V6.27631C4 5.80936 4.28966 5.39138 4.72688 5.22742M3 3.5L21 21.5",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/svg3.78555e1b9b4f0e38e668c37aecca3d9a.svg";
export { ForwardRef as ReactComponent };